const map: Json = {
  'https://sloyd.ai/roles': 'roles',
  'https://sloyd.ai/username': 'username',
  given_name: 'givenName',
  family_name: 'familyName',
  nickname: 'nickname',
  name: 'name',
  picture: 'picture',
  updated_at: 'updatedAt',
  email: 'email',
  email_verified: 'emailVerified',
  sub: 'sub',
};

export const parseUser = (user: Json) => {
  const output = Object.keys(user).reduce((acc, key) => {
    const newKey = map[key] || key;
    acc[newKey] = user[key];
    return acc;
  }, {} as Json);

  return output;
};
